<template>
	<div class="main">
		<section class="panel">
			<section class="panel panel-default" v-if="isAdmin('assist')">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse in">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="year" class="col-sm-4 col-xs-2">學年度</label>
								<div class="col-sm-8 col-xs-10">
									<select id="year" name="year" v-model="qryParam.year" class="form-control">
										<option value="">請選擇</option>
											<option v-for="item in yearList" :key="item" :value="item">{{item}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="ssym" class="col-sm-4 col-xs-2">學制</label>
								<div class="col-sm-8 col-xs-10">
									<select id="ssym" name="ssym" v-model="qryParam.ssym" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
										</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="dept" class="col-sm-4 col-xs-2">科系</label>
								<div class="col-sm-8 col-xs-10">
									<select id="dept" name="dept" v-model="qryParam.dept" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
										</option>
									</select>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="drade" class="col-sm-4 col-xs-2">年級</label>
								<div class="col-sm-8 col-xs-10">
									<select id="drade" name="drade" v-model="qryParam.drade" class="form-control">
										<option value="">請選擇</option>
										<option value="1">一年級</option>
										<option value="2">二年級</option>
										<option value="3">三年級</option>
										<option value="4">四年級</option>
										<option value="5">五年級</option>
										<option value="6">六年級</option>
										<option value="7">七年級</option>
										<option value="8">八年級</option>
										<option value="9">九年級</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="class" class="col-sm-4 col-xs-2">班級</label>
								<div class="col-sm-8 col-xs-10">
									<select id="class" name="class" v-model="qryParam.class" class="form-control">
										<option value="">請選擇</option>
										<option value="A">A班</option>
										<option value="B">B班</option>
										<option value="C">C班</option>
                    <option value="D">D班</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="account" class="col-sm-4 col-xs-2">學號</label>
								<div class="col-sm-8 col-xs-10">
									<input id="account" name="account" type="text" v-model="qryParam.account" class="form-control" />
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="name" class="col-sm-4 col-xs-2">姓名</label>
								<div class="col-sm-8 col-xs-10">
									<input id="name" name="name" type="text" v-model="qryParam.name" class="form-control" />
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="sex" class="col-sm-4 col-xs-2">性別</label>
								<div class="col-sm-8 col-xs-10">
									<select id="sex" name="sex" v-validate="'required'" v-model="qryParam.sex" class="form-control">
										<option value="">請選擇</option>
										<option value="M">男</option>
										<option value="F">女</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="state" class="col-sm-4 col-xs-2">資料合格</label>
								<div class="col-sm-8 col-xs-10">
									<select id="state" name="state" v-model="qryParam.state" class="form-control">
										<option value="">請選擇</option>
										<option value="0">草稿</option>
										<option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
										</option>
									</select>
								</div>
							</div>
						</div>
						<div class="row form-group">
              <div class="col-md-4 form-group">
                <label for="lastState" class="col-sm-4 col-xs-2">最終狀態</label>
                <div class="col-sm-8 col-xs-10">
                  <select id="lastState" name="lastState" v-model="qryParam.lastState" class="form-control">
                    <option value="">請選擇</option>
                    <option value="1">合格</option>
                    <option value="2">不合格</option>
                  </select>
                </div>
              </div>
							<div class="col-md-4 form-group">
								<button @click="searchWeakApply" class="btn s_btn_b">查詢</button>
								<button @click="clearSearchParam" class="btn s_btn_g">清除</button>
								<button @click="exportExcel" class="btn s_btn_b">匯出</button>
							</div>
						</div>
						<hr/>
						<h4 style="font-weight: bold">{{lastestYearState.smtr}} 學年度申請狀態</h4>
						<div class="col-md-12">
							<div class="col-md-2">
								<h5>全部件數 : {{lastestYearState.total}} </h5>
							</div>
							<div class="col-md-2">
								<h5>待審核件數 : {{lastestYearState.pending}} </h5>
							</div>
							<div class="col-md-2">
								<h5>合格件數 : {{lastestYearState.approval}} </h5>
							</div>
							<div class="col-md-2">
							<h5 >不合格件數 : {{lastestYearState.reject}} </h5>
							</div>
							<div class="col-md-2">
								<h5>待補件件數 : {{lastestYearState.incomplete}} </h5>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="panel panel-default">
				<div class="tab-content">
					<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
						<div class="row form-group" v-if="JSON.stringify(this.sessionData) != '{}'">
							<div class="col-md-12 text-left form-inline">
                                <button @click="gotoView('weak.apply.new')" class="btn s_btn_o">新增</button>
								<button
									v-if="isAdmin('assist')"
									@click="transferToAccounting"
									class="btn s_btn_b"
									:disabled="isTransfering"
								>
									{{isTransfering ? "轉入中..." : "轉入會計系統"}}
								</button>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<table class="table table-no-more table-bordered table-striped mb-none" >
									<thead>
										<tr >
											<th v-if="isAdmin('assist')" class="text-center" width="5%">
												<input
													ref="selectAllCheckbox"
													type="checkbox"
													id="selectAllMatched"
													name="selectAllMatched"
													:checked="selectAllMatched"
													@change="toggleSelectAllMatched"
												/>
											</th>
											<th class="text-center" width="5%">序號</th>
											<th class="text-center" width="15%">申請學年度</th>
											<th class="text-center" width="20%">學號</th>
											<th class="text-center" width="15%">姓名</th>
											<th v-if="isAdmin('assist')" class="text-center" width="15%">等級</th>
											<th v-if="isAdmin('assist')" class="text-center" width="20%">資料合格</th>
                      <th v-if="!isAdmin('assist')" class="text-center" width="20%">備註</th>
                      <th v-if="isAdmin('assist')" class="text-center" width="10%">最終狀態</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in weakApplyList" :key="index">
											<td v-if="isAdmin('assist')" data-title="勾選" class="text-center" >
												<input
													v-if="item.canTransferToAccounting"
													:id="'checkId_' + item.id"
													type="checkbox"
													name="checkId"
													:checked="isRowSelected(item)"
													@change="toggleRowSelection(item, $event)"
												/>
											</td>
											<td data-title="序號" class="text-center" >{{index + 1}}</td>
											<td data-title="申請學年度" class="text-center" >{{item.year}}</td>
											<td data-title="學號" class="text-center" >{{item.account}}</td>
											<td data-title="姓名" class="text-center" >
												<a class="btn-link" style="cursor: pointer;" @click="gotoView('weak.apply.edit', {weakApplyId: item.id, isFromIdnoSearch: isFromIdnoSearch})">{{item.name}}</a>
											</td>
											<td v-if="isAdmin('assist')" data-title="申請類別" class="text-center" >{{getClassText(item.moeReviewClass)}}</td>
											<td v-if="isAdmin('assist')" data-title="審核狀態" class="text-center" >{{item.schReviewStateStr}}</td>
                      <td v-if="!isAdmin('assist')" data-title="備註" class="text-center" >{{item.schReviewState === '0' ? item.schReviewStateStr : ''}}</td>
                      <td v-if="isAdmin('assist')" data-title="最終狀態" class="text-center" >
                        {{item.moeReviewMinistry == "F" && item.moeReview == "合格" ? "合格" :
                        !!item.moeReviewMinistry || item.moeReview == "不合格" ? "不合格" : ""}}
                      </td>
										</tr>
									</tbody>
								</table>

							</div>
							<div class="col-md-12">
								<div class="text-center" v-if="isAdmin('assist')">
									<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</section>
	</div>
</template>
<script>
/* global bootbox */

function createDefaultQryParam() {
	return {
		year: "",
		ssym: "",
		dept: "",
		drade: "",
		class: "",
		account: "",
		name: "",
		sex: "",
		weakType: "",
		state: "",
		withoutDraft: true,
		idNo: "",
		lastState: ""
	};
}

function cloneQryParam(source) {
	return {
		...createDefaultQryParam(),
		...(source || {})
	};
}

function createPlainTextAlertElement(message) {
	const container = document.createElement("div");
	container.style.whiteSpace = "pre-line";
	container.textContent = message || "";
	return container;
}

export default {
	data() {
		return {
			qryParam: createDefaultQryParam(),
			appliedQryParam: createDefaultQryParam(),
			lastestYearState: {
				year: "",
				total: 0,
				pending: 0,
				approval: 0,
				reject: 0,
				incomplete: 0
			},
			weakApplyList: [],
			page: 1,
			totalPage: 1,
			// 下拉選單來源
			ssymList: [],
			deptList: [],
			applyTypeList: [],
			schreviewStateList: [],
			yearList: [],

			// 透過身分證字號查詢進入
			isFromIdnoSearch: false,
			selectedIds: [],
			excludedIds: [],
			selectAllMatched: false,
			matchedRowCount: 0,
			isTransfering: false,
		};
	},
	mounted() {
		this.pageInit();
	},
	updated() {
		this.syncSelectAllCheckboxState();
	},
	computed: {
		hasTransferSelection() {
			return this.selectAllMatched || this.selectedIds.length > 0;
		},
		selectionQueryKey() {
			return JSON.stringify(this.appliedQryParam);
		}
	},
	watch: {
		selectionQueryKey(newValue, oldValue) {
			if (oldValue !== undefined && newValue !== oldValue) {
				this.resetSelectionState();
			}
		}
	},
	methods: {
		pageInit() {
			if(this.isAdmin('assist')) {
				let api = "/api/weak/listInit";
				this.$axios.get(api).then(res => {
					this.ssymList = res.data.data.selectList.ssym
					this.deptList = res.data.data.selectList.dept
					this.schreviewStateList = res.data.data.selectList.reviewState
          this.yearList = res.data.data.selectList.year
				});

				api = "/api/weak/getLastestYearState";
				this.$axios.get(api).then(res => {
					this.lastestYearState = res.data.data;
				});

				// 套用查詢設定
				const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
				if(storeQryParam != null) {
					this.qryParam = cloneQryParam(storeQryParam);
				}

				const storeAppliedQryParam = JSON.parse(this.getStore(`${this.$route.name}.appliedQryParam`));
				if(storeAppliedQryParam != null) {
					this.appliedQryParam = cloneQryParam(storeAppliedQryParam);
				} else {
					this.appliedQryParam = cloneQryParam(this.qryParam);
				}

				const storePage = this.getStore(`${this.$route.name}.page`);
				if(storePage != null) {
					this.page = storePage;
        }
			}
			else if(JSON.stringify(this.sessionData) != '{}'){
				this.qryParam.account = this.sessionData.account;
				this.qryParam.withDraft = true;
				this.appliedQryParam = cloneQryParam(this.qryParam);
			} else {
				this.isFromIdnoSearch = true;
				this.qryParam.idNo = JSON.parse(this.getStore(this.$route.name)).idNo;
				this.appliedQryParam = cloneQryParam(this.qryParam);
			}

			if (JSON.stringify(this.appliedQryParam) === JSON.stringify(createDefaultQryParam())) {
				this.appliedQryParam = cloneQryParam(this.qryParam);
			}

      this.updateGrid(this.page);
		},
		updateGrid(page = 1) {
			//更新Grid 必需
			this.page = page;

			const api = "/api/weak";
			const query = new URLSearchParams({
				...this.appliedQryParam,
				page: this.page,
				pageSize: 10,
			}).toString();
			return this.$axios.get(`${api}?${query}`).then(resp =>{
				if(resp.data.status === "success") {
					const matchedRowCount = Number(resp.data.data.rowNum) || 0;

					this.weakApplyList = resp.data.data.rows;
					this.matchedRowCount = matchedRowCount;
					this.totalPage = Math.ceil(matchedRowCount / resp.data.data.pageSize);
					this.page = resp.data.data.page;
				} else {
					this.showPlainTextAlert(resp.data.msg || "查詢失敗");
				}
			});
		},
		searchWeakApply() {
			this.resetSelectionState();
			this.appliedQryParam = cloneQryParam(this.qryParam);
			return this.updateGrid(1);
		},
		isRowSelected(item) {
			if (!item.canTransferToAccounting) {
				return false;
			}

			if (this.selectAllMatched) {
				return this.excludedIds.indexOf(item.id) === -1;
			}

			return this.selectedIds.indexOf(item.id) !== -1;
		},
		toggleSelectAllMatched(event) {
			this.selectAllMatched = event.target.checked;
			this.selectedIds = [];
			this.excludedIds = [];
		},
		toggleRowSelection(item, event) {
			if (!item.canTransferToAccounting) {
				return;
			}

			const isChecked = event.target.checked;

			if (this.selectAllMatched) {
				if (isChecked) {
					this.excludedIds = this.excludedIds.filter(id => id !== item.id);
				} else if (this.excludedIds.indexOf(item.id) === -1) {
					this.excludedIds = this.excludedIds.concat(item.id);
				}
				return;
			}

			if (isChecked) {
				if (this.selectedIds.indexOf(item.id) === -1) {
					this.selectedIds = this.selectedIds.concat(item.id);
				}
				return;
			}

			this.selectedIds = this.selectedIds.filter(id => id !== item.id);
		},
		resetSelectionState() {
			this.selectedIds = [];
			this.excludedIds = [];
			this.selectAllMatched = false;
		},
		showPlainTextAlert(message, callback) {
			bootbox.alert({
				message: createPlainTextAlertElement(message),
				callback
			});
		},
		syncSelectAllCheckboxState() {
			this.$nextTick(() => {
				const checkbox = this.$refs.selectAllCheckbox;
				if (checkbox) {
					checkbox.indeterminate = this.selectAllMatched && this.excludedIds.length > 0;
				}
			});
		},
		getTransferQuery() {
			return cloneQryParam(this.appliedQryParam);
		},
		buildTransferPayload() {
			if (this.selectAllMatched) {
				return {
					selectAllMatched: true,
					query: this.getTransferQuery(),
					selectedIds: [],
					excludedIds: this.excludedIds.slice()
				};
			}

			return {
				selectAllMatched: false,
				query: null,
				selectedIds: this.selectedIds.slice(),
				excludedIds: []
			};
		},
		getTransferResultMessage(responseData) {
			const summaryMessage = responseData && responseData.msg
				? responseData.msg
				: "轉入會計系統完成";
			const failures = responseData.data && Array.isArray(responseData.data.failures)
				? responseData.data.failures
				: [];

			if (failures.length === 0) {
				return summaryMessage;
			}

			return [summaryMessage, "", "失敗明細："].concat(failures.map(item => `${item}`)).join("\n");
		},
		transferToAccounting() {
			if (!this.hasTransferSelection) {
				this.showPlainTextAlert("請先勾選要轉入會計系統的資料");
				return;
			}

			if (this.selectAllMatched && this.matchedRowCount === 0) {
				this.showPlainTextAlert("目前查無符合條件的資料可轉入會計系統");
				return;
			}

			bootbox.confirm("是否確認將選取資料轉入會計系統？", async result => {
				if (!result || this.isTransfering) {
					return;
				}

				this.isTransfering = true;

				try {
					const resp = await this.$axios.post("/api/weak/transferToAccounting", this.buildTransferPayload());

					if (resp.data.status === "success") {
						this.showPlainTextAlert(this.getTransferResultMessage(resp.data), () => {
							this.resetSelectionState();
							this.updateGrid(this.page);
						});
					} else {
						this.showPlainTextAlert(resp.data.msg || "轉入會計系統失敗");
					}
				} catch (error) {
					const errorMsg = error && error.response && error.response.data && error.response.data.msg
						? error.response.data.msg
						: "轉入會計系統失敗，請稍後再試";
					this.showPlainTextAlert(errorMsg);
				} finally {
					this.isTransfering = false;
				}
			});
		},
		exportExcel(){
			const api = "/api/weak/export";
			const query = new URLSearchParams({
				...this.qryParam,
				page: 0,
				pageSize: 0,
			}).toString();
			this.$axios.get(`${api}?${query}`, {
				responseType: 'blob'
			}).then(resp =>{
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `弱勢助學金申請資料_${this.customFormatter(new Date(),"YYYYMMDD")}.xlsx`);
				document.body.appendChild(link);
				link.click();
			});
		},
		clearSearchParam(){
			this.qryParam = createDefaultQryParam();
			this.resetSelectionState();
			this.removeStore(`${this.$route.name}.appliedQryParam`);
			this.removeStore(`${this.$route.name}.qryParam`);
			this.removeStore(`${this.$route.name}.page`);
		},
		getClassText(value) {
			switch (value){
				case "1":
					return "第一級";
				case "2":
					return "第二級";
				case "3":
					return "第三級";
				case "4":
					return "第四級";
				case "5":
					return "第五級";
				case "6":
					return "第六級";
				default:
					return "";
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		// 保留查詢設定
		if(to.name.startsWith("weak.apply.")) {
			this.setStore(`${this.$route.name}.qryParam`, this.qryParam);
			this.setStore(`${this.$route.name}.appliedQryParam`, this.appliedQryParam);
			this.setStore(`${this.$route.name}.page`, this.page);
		} else {
			this.removeStore(`${this.$route.name}.page`);
			this.removeStore(`${this.$route.name}.appliedQryParam`);
			this.removeStore(`${this.$route.name}.qryParam`);
		}

		this.removeStore(this.$route.name);
		next();
	}
};
</script>
